import { render, staticRenderFns } from "./ContactInformation.vue?vue&type=template&id=8b157522&scoped=true&"
import script from "./ContactInformation.vue?vue&type=script&lang=js&"
export * from "./ContactInformation.vue?vue&type=script&lang=js&"
import style0 from "./ContactInformation.vue?vue&type=style&index=0&id=8b157522&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b157522",
  null
  
)

export default component.exports